import { useTranslation } from "react-i18next";

import { Column, FloatingLabelSelect, Typography } from "@aviary";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthMarginPercentage.styles";

interface Props {
  value: string;
  onChange: (values: string) => void;
  profitMarginIncrements: number[];
}

const OAuthMarginPercentage = ({ value, onChange, profitMarginIncrements }: Props) => {
  const { t } = useTranslation();
  const maxProfitMargin = Math.max(...profitMarginIncrements);

  const patientSavingsBlurb =
    value === "" ? (
      <Typography type="footnote">{t(l.oauth.selectThePercentageTo)}</Typography>
    ) : (
      <Typography type="footnote">
        {t(l.oauth.yourPatientSavings)} {maxProfitMargin - parseInt(value, 10)}%
      </Typography>
    );

  return (
    <div>
      <Typography type="h4" sizeOverride="h5">
        {t(l.oauth.marginPercentage)}
      </Typography>
      <Typography>{t(l.oauth.selectWhatPercentage)}</Typography>
      <Column columnWidth={6} isPaddingless css={styles.field}>
        <FloatingLabelSelect
          data-testid="margin-percentage-select"
          id="margin-percentage"
          name="margin-percentage"
          label={t(l.oauth.selectThePercentage)}
          value={value}
          handleChange={e => {
            onChange(e.target.value);
          }}
          required
        >
          <option value="" key="" disabled>
            {t(l.sharedCommon.Select)}
          </option>
          {profitMarginIncrements?.map(marginIncrement => {
            return (
              <option key={marginIncrement} value={marginIncrement}>
                {marginIncrement}
              </option>
            );
          })}
        </FloatingLabelSelect>
      </Column>
      <Typography type="footnote">{patientSavingsBlurb}</Typography>
    </div>
  );
};

export { OAuthMarginPercentage };
